export const eventDateTypes = {
    singleDate: 2,
    dualDate: 3,
} as const
